let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eEmWq")).then(() => parcelRequire('hVV5E'));